import API from "../components/helpers/endpointservice";
import axios from "axios";
import Actions from './api';
import {jwtDecode} from "jwt-decode";

export const getUser = (data) => {
  return (dispatch) => {
    //Loader true
    dispatch({ type: "IS_LOADER", data: true });
    Actions.POST(`${API.GET_USERS_LIST}`, data).then((res) => {
      if (res.data !== undefined) {
        dispatch({ type: "USERS_LOADED_SUCCESS", data: res.data });
      }
      //Loader false
      dispatch({ type: "IS_LOADER", data: false });
    }).catch((error) => {
      console.log("error", error)
      //Loader false
      dispatch({ type: "IS_LOADER", data: false });
    });
  };
};

export const getParticularUser = (id) => {
  return (dispatch) => {
    //Loader true
    dispatch({ type: "IS_LOADER1", data: true });
    dispatch({ type: "Add_User_IS_LOADER", data: true });
    return Actions.GET(`${API.GET_USER}${id}`).then((res) => {
      if (res.data !== undefined) {
        dispatch({ type: "USER_LOADED_SUCCESS", data: res.data });
        dispatch({ type: "IS_LOADER1", data: false });
        dispatch({ type: "IS_LOADER", data: false });
        dispatch({ type: "IS_LOADING", data: false });
        dispatch({ type: "Add_User_IS_LOADER", data: false });

      }
      //Loader false
      dispatch({ type: "Add_User_IS_LOADER", data: false });
      dispatch({ type: "IS_LOADER1", data: false });
      dispatch({ type: "IS_LOADER", data: false });
      dispatch({ type: "IS_LOADING", data: false });
      return res;
    }).catch((error) => {
      console.log("error", error)
      //Loader false
      dispatch({ type: "Add_User_IS_LOADER", data: false });
      dispatch({ type: "IS_LOADER1", data: false });
      dispatch({ type: "IS_LOADER", data: false });
      dispatch({ type: "IS_LOADING", data: false });
      return error;
    })
  }
};

export const addUser = (data) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      //Loader true
      dispatch({ type: "Add_User_IS_LOADER", data: true });
      Actions.POST(`${API.POST_USER}`, data).then((res) => {
        if (res.data !== undefined) {
          dispatch({ type: "USER_ADDED_SUCCESS", data: res.status });
          // dispatch({ type: "USER_API_SUCCESS", data: true});

          resolve(res.data);
          dispatch({ type: "Add_User_IS_LOADER", data: false });
        }
        else {
          reject(new Error("No data in response"));
          dispatch({ type: "Add_User_IS_LOADER", data: false });
        }
        //Loader false
        dispatch({ type: "Add_User_IS_LOADER", data: false });
      })
        .catch((error) => {
          dispatch({ type: "Add_User_IS_LOADER", data: false });
          console.log("error", error)
          //Loader false
          dispatch({ type: "USER_ADDED_SUCCESS", data: error.request.status });
          dispatch({ type: "Add_User_IS_LOADER", data: false });
          reject(error)
        });
      dispatch({ type: "Add_User_IS_LOADER", data: false });
    });

  };

};

export const updateUser = (data, id) => {

  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({ type: "Add_User_IS_LOADER", data: true });
      Actions.PUT(`${API.PUT_USER}/${id}`, data).then((res) => {
        if (res.data !== undefined) {

          dispatch({ type: "USERS_LOADED_SUCCESS", data: res.data });
          // dispatch({ type: "USER_UPDATE_SUCCESS", data: false });
          dispatch({ type: "Add_User_IS_LOADER", data: false });
          console.log(res.data);
          resolve(res.data);
          return res.data;
        }
        else {
          reject(new Error("No data in response"));
        }
        //Loader false
        // dispatch({ type: "Add_User_IS_LOADER", data: false });
      })
        .catch((error) => {
          console.log("error", error)
          //Loader false
          dispatch({ type: "USER_UPDATE_SUCCESS", data: false });
          dispatch({ type: "Add_User_IS_LOADER", data: false });
          reject(error)
        });
    });
  };
};

export const changePassword = (data) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      //Loader true
      dispatch({ type: "Add_User_IS_LOADER", data: true });
      Actions.PUT(`${API.CHANGE_PASSWORD}`, data).then((res) => {
        if (res.data !== undefined) {
          console.log(res);
          resolve(res.data);
          dispatch({ type: "PASSWORD_CHANGED", data: res.data });

        }
        else {
          reject(new Error("No data in response"));
        }
        //Loader false
        dispatch({ type: "Add_User_IS_LOADER", data: false });
      })
        .catch((error) => {
          console.log("error", error)

          dispatch({ type: "Add_User_IS_LOADER", data: false });
          dispatch({ type: "PASSWORD_CHANGED", data: data });
          reject(error)
        });
    });
  };
};

export const deleteUser = (data) => {

  return async (dispatch) => {
    dispatch({ type: "Add_User_IS_LOADER", data: true });
    await Actions.DELETE(`${API.DELETE_USER}`, data)
      .then((response) => {
        dispatch({
          type: "USERS_LOADED_SUCCESS",
          data: {},
        });
        dispatch({ type: "Add_User_IS_LOADER", data: false });
        dispatch({ type: "USER_DELETED", data: response });
      })
      .catch((error) => {
        // dispatch({ type: "USER_DELETED_SUCCESS", data: error });
        if (error.response.status === 401) {
          // logOut();
          dispatch({ type: "Add_User_IS_LOADER", data: false });
        }
        // this.setState({ error: error });
        dispatch({ type: "Add_User_IS_LOADER", data: false });
      });
    dispatch({ type: "Add_User_IS_LOADER", data: false });
  };
};


export const LastLogin = () => {
  return (dispatch) => {
    return new Promise(async (resolve, reject) => {
      dispatch({ type: "IS_LOADER", data: true });

      await Actions.PUT(`${API.LAST_LOGIN}`).then((res) => {
        if (res.data !== undefined) {
          dispatch({ type: "IS_LOADER", data: false });
          resolve(res.data);
        }
        else {
          reject(new Error("No data in response"));
          dispatch({ type: "IS_LOADER", data: false });
        }
        dispatch({ type: "IS_LOADER", data: false });
      })
        .catch((error) => {
          console.log("error", error)
          dispatch({ type: "IS_LOADER", data: false });
          reject(error)
        });
    });
  };
};




export const VerifyInviteFromLink = (data) => {

  return async (dispatch) => {
    //Loader true
    dispatch({ type: "IS_LOADER", data: true });
    return await Actions.POST(`${API.VERIFY_INVITE}`, data).then(async (res) => {
      if (res.data !== undefined) {
        dispatch({ type: "VERIFY_INVITE_LINK", data: res.data });
        console.log(res.data.user.invitee.firstName);
        if (res.data.user.isSSO == true) {
          localStorage.setItem('inviteemailTAC', res.data.user.invitee.email)
          localStorage.setItem('invitenameTAC', res.data.user.invitee.firstName)
          localStorage.setItem('realmNTAC', res.data.user.tenant)
          localStorage.setItem('firstnameTAC', res.data.user.firstName)
          localStorage.setItem('lastnameTAC', res.data.user.lastName)
          localStorage.setItem('phoneTAC', res.data.user.phoneNumber)
          localStorage.setItem('isSSOTAC', res.data.user.isSSO)
        }
        else {
          localStorage.setItem('inviteemailTAC', res.data.user.invitee.email)
          localStorage.setItem('invitenameTAC', res.data.user.invitee.firstName)
          localStorage.setItem('realmNTAC', res.data.user.tenant)
          localStorage.setItem('firstnameTAC', res.data.user.firstName)
          localStorage.setItem('lastnameTAC', res.data.user.lastName)
          localStorage.setItem('phoneTAC', res.data.user.phoneNumber)
          localStorage.setItem('isSSOTAC', res.data.user.isSSO)
          localStorage.setItem('userNameTAC', res.data.user.email)
          // window.location.href='/users'
        }
      }
      else if (res.data.status == "Fail") {
        //  window.location.href='/alreadyjoined'
      }
      //Loader false
      dispatch({ type: "IS_LOADER", data: false });
    }).catch((error) => {
      console.log("error", error)
      // window.location.href='/alreadyjoined'

      //Loader false
      dispatch({ type: "IS_LOADER", data: false });
    });
  };
};

export const resetpassword = (data) => {

  return async (dispatch) => {

    dispatch({ type: "IS_LOADER", data: true });
    await Actions.POST(`${API.RESET_API}`, data).then((res) => {
      if (res.data !== undefined) {
        // window.location.href = "/key";
        window.location.href = "/admin/key";
        console.log(res.data);
        let realmname = localStorage.getItem('realmNTAC')
        localStorage.setItem('realmNameTAC', realmname)
        dispatch({ type: "RESET_API", data: res.data });
        console.log(jwtDecode(res.data?.token.accessToken));
        localStorage.setItem("AccessTokenTAC", res.data?.token.accessToken)
        localStorage.setItem("RefreshTokenTAC", res.data?.token.refreshToken);

      }
      //Loader false
      dispatch({ type: "IS_LOADER", data: false });
    }).catch((error) => {
      console.log("error", error)
      //Loader false
      dispatch({ type: "IS_LOADER", data: false });
    });
  };
};



